import { render } from "./index.vue?vue&type=template&id=b1f06aaa&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=b1f06aaa&lang=scss&scoped=true"

import exportComponent from "E:\\work\\高大\\dealer-pda\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1f06aaa"]])

export default __exports__